export const STREAMING_TEXT_CHARACTER_DELAY_MS = 28
